import { createContext } from "react";
import { ITranslationFunc, t } from ".";
import { list } from "./en";

export const i18nContext = createContext<[ITranslationFunc]>([t(list)]);
